<form [formGroup]="passwordForm" (ngSubmit)="onSubmit()">
    <div class="title">
        {{title}}
    </div>
    <div class="input-container">
        <label>
            Nueva contraseña
            <span class="mandatory">*</span>
        </label>
        <input class="form-input" formControlName="password" type="password" autocomplete="off"
            autocorrect="off" autocapitalize="off" spellcheck="false"
            [ngClass]="{'error':hasErrors() && hasSubmitted}">
    </div>
    <div class="input-container">
        <label>
            Confirmar contraseña
            <span class="mandatory">*</span>
        </label>
        <input class="form-input" formControlName="confirmPassword" type="password" autocomplete="off"
            autocorrect="off" autocapitalize="off" spellcheck="false"
            [ngClass]="{'error':hasErrors() && hasSubmitted}">
    </div>
    <div class="errors">
        <small>
            <img [src]="(!!getError('notValueInRange'))?errorImg:successImg" alt="check">
            La contraseña debe tener entre 8 y 20 caracteres
        </small>
        <small>
            <img [src]="!!getError('notUpper')?errorImg:successImg" alt="check">
            La contraseña debe tener mínimo una mayúscula
        </small>
        <small>
            <img [src]="!!getError('notNumber')?errorImg:successImg" alt="check">
            La contraseña debe tener mínimo un número
        </small>
        <small>
            <img [src]="!!getError('notWhiteSpaces')?errorImg:successImg" alt="check">
            La contraseña no debe contener espacios
        </small>
        <small>
            <img [src]="!!passwordForm.errors?.['notEqual']?errorImg:successImg" alt="check">
            Las contraseñas deben coincidir
        </small>
    </div>
    <button class="btn-submit" [disabled]="isLoading">Confirmar</button>
</form>